module.exports = __webpack_public_path__ + "img/table-plus.73c3078a.svg";